import React, { Component } from 'react';
import validate from "validate.js";
import scrollToElement from 'scroll-to-element';

function ErrorSpan(props) {
  let elm = '';
  if(props.error){
    elm = props.error.map((data,i) => {
        return <span className="error" key={i}>{data}</span>;
    })
  }
  return elm;
}

class FirstPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errors:{
      },
      valid: false
    };

  }

  valicheck(){
    var that = this;
    if(that.state.valid){
      let data = that.get_form_data();
      that.validation(data);
    }

  }

  validation(obj){
    let constraints = {
      name: {
        presence: {
          message: '^必須項目です。',
          allowEmpty: false
        },
      },
      email: {
        presence: {
          message: '^必須項目です。',
          allowEmpty: false
        },
        email: {
          message: '^正しいEmailを入力してください。',
        }
      },
      subject: {
        presence: {
          message: '^必須項目です。',
          allowEmpty: false
        },
      },
      shop: {
        presence: {
          message: '^必須項目です。',
          allowEmpty: false
        },
      },
      inquiry_txt: {
        presence: {
          message: '^必須項目です。',
          allowEmpty: false
        },
      },
    };
    let errors = validate(obj, constraints);
    if(errors){

      this.setState({ errors: errors, valid: true })
      //エラー
      return false;
    }
    this.setState({ errors: {} })
    return true;
  }

  get_form_data(){
    let data = {
      name : this.refs.name.value,
      email : this.refs.email.value,
      subject : this.refs.subject.value,
      inquiry_txt : this.refs.inquiry_txt.value,
      shop : this.refs.shop.value,
    }
    return data;
  }

  onConfirm(e){
    var that = this;
    var data = that.get_form_data();

    //バリデーション
    if(!that.validation(data)){

      setTimeout(function(){
        scrollToElement('.in-error', {
          offset: -180,
          ease: 'linear',
          duration: 300
        });
      },50);
      return false;
    }
    this.props.saveValues(data)

    that.props.nextStep();


  }

  render() {

    return (

    <div className="first_page">
      <h2 className="contact">ご連絡先/お問合せ内容</h2>
       <div>
         <div className="row">
           <div className={"six columns form-groups " + (this.state.errors.name  ? 'in-error' : '')}>
             <label htmlFor="name_female">
               <span>お名前</span><span className="help">  (フルネーム)</span><span className="help require-color">※</span>
             </label>
             <input className="u-full-width" type="text" placeholder="お名前" ref="name" defaultValue={ this.props.fieldValues.name } onChange={this.valicheck.bind(this)} />
             <ErrorSpan error={this.state.errors.name} />
           </div>
           <div className={"six columns form-groups " + (this.state.errors.email  ? 'in-error' : '')}>
             <label htmlFor="email">
               <span>E-mail</span>
               <span className="help require-color">※</span>
             </label>
             <input className="u-full-width" type="email" placeholder="E-mail" ref="email" defaultValue={ this.props.fieldValues.email } onChange={this.valicheck.bind(this)} />
             <ErrorSpan error={this.state.errors.email} />
           </div>
         </div>
         <div className="row">
           <div className={"six columns form-groups " + (this.state.errors.subject  ? 'in-error' : '')}>
             <label htmlFor="subject">
               <span>件名</span>
               <span className="help require-color">※</span>
             </label>
             <input className="u-full-width" type="text" placeholder="件名" ref="subject" defaultValue={ this.props.fieldValues.subject } onChange={this.valicheck.bind(this)} />
             <ErrorSpan error={this.state.errors.subject} />
           </div>
           <div className={"six columns form-groups " + (this.state.errors.shop  ? 'in-error' : '')}>
             <label htmlFor="shop">
               <span>お問合せ店名</span>
               <span className="help require-color">※</span>
             </label>
             <select  className="u-full-width" ref="shop" defaultValue={ this.props.fieldValues.shop } onChange={this.valicheck.bind(this)}>
               <option value="">お問合せ先を選択して下さい</option>
               <option value="2">銀座店へのお問い合わせ</option>
               <option value="3">その他のお問い合わせ</option>
             </select>
             <ErrorSpan error={this.state.errors.shop} />
           </div>
         </div>
         <div className="row">
           <div className={"twelve columns form-groups " + (this.state.errors.inquiry_txt  ? 'in-error' : '')}>
             <label htmlFor="inquiry_txt">
               <span>お問合せ内容</span><span className="help require-color">※</span>
             </label>
             <textarea name="inquiry_txt" style={{height:"200px"}} className="u-full-width"  ref="inquiry_txt" defaultValue={ this.props.fieldValues.inquiry_txt } onChange={this.valicheck.bind(this)}></textarea>
             <ErrorSpan error={this.state.errors.inquiry_txt} />
           </div>
         </div>
       </div>

      <div className="btn_box">
        <input type="button" value="確認画面へ >>" onClick={ this.onConfirm.bind(this) } />
      </div>
    </div>
    );
  }
}

//FirstPage.propTypes = {
//  nextStep: React.PropTypes.func,
//};

export default FirstPage;



// WEBPACK FOOTER //
// ./src/contact/FirstPage.js